import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faPlus } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import { createAddOnService } from "../../api/AddOnService";
import toast from "react-hot-toast";
import ConfirmationModal from "../../components/ConfirmationModal";
import LoadingTablePage from "../LoadingTablePage";
import EditForm from "../../components/EditForm";
import AddOnServiceForm from "../../components/addOnServices/AddOnServiceForm";
import Breadcrumbs from "../../components/Breadcrumbs";
import { getBillingGroupsByAgreement } from "../../api/BillingGroups";
import { set } from "date-fns";

const CreateAddOnServicePage = () => {
  const { getAccessToken, user } = useAuth();
  const { agreementPublicId } = useParams();
  const navigate = useNavigate();
  const [addOnService, setAddOnService] = useState({
    name: "",
    price: "",
    billingGroupPublicId: "",
    comment: "",
  });
  const [hasChanges, setHasChanges] = useState(false);
  const [billingGroups, setBillingGroups] = useState([]);
  const [confirmState, setConfirmState] = useState({ isOpen: false });

  useEffect(() => {
    handleGetBillingGroups();
  }, []);

  const handleGetBillingGroups = async () => {
    try {
      const accessToken = await getAccessToken();
      const groups = await getBillingGroupsByAgreement(agreementPublicId, accessToken);
      setBillingGroups(groups);
    } catch (error) {
      console.error("Failed to fetch billing groups:", error);
    }
  };

  const handleBillingGroupChange = (selectedName) => {
    const selectedGroup = billingGroups.find((group) => group.name === selectedName);
    if (!selectedGroup) return;

    setAddOnService((prevAddOnService) => ({
      ...prevAddOnService,
      billingGroupName: selectedGroup.name,
      billingGroupPublicId: selectedGroup.billingGroupPublicId,
    }));
    setHasChanges(true);
  };

  const handleCreateAddOnService = async () => {
    try {
      const accessToken = await getAccessToken();
      if (!accessToken) {
        toast.error("Authorization failed. Please log in again.");
        return;
      }

      const addOnServiceData = {
        name: addOnService.name || "",
        billingGroupPublicId: addOnService.billingGroupPublicId || "",
        comment: addOnService.comment || "",
        price: addOnService.price || 0,
        updatedDateTimeUTC: new Date().toISOString(),
        updatedBy: user?.username,
        createdBy: user?.username,
        createdDateTimeUTC: new Date().toISOString(),
      };

      console.log("Data:", addOnServiceData);


      await createAddOnService(addOnServiceData, accessToken);
      
      toast.success("Add on service created successfully", {
        iconTheme: {
          primary: "#4CAF50",
          secondary: "#DFF2BF",
        },
      });

      navigate(-1);
    } catch (error) {
      toast.error("Failed to create add on service");
    }
  };

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="absolute w-full pointer-events-none">
            <LoadingTablePage title={"Create add on service"} loading={false} />
          </div>
          <div className="page-content">
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <button onClick={() => navigate(-1)} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Create Add-on service</h2>
              <div className="flex gap-4 ml-auto">
                <button className="btn btn-outline-primary" onClick={() => navigate(-1)}>Cancel</button>
                <button className="btn btn-primary" disabled={!hasChanges} onClick={handleCreateAddOnService}>
                Save
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
            <AddOnServiceForm
            addOnService={addOnService}
            setAddOnService={setAddOnService}
            setHasChanges={setHasChanges}
            billingGroups={billingGroups}
            onBillingGroupChange={handleBillingGroupChange}
            disabledFields={[              
              "createdBy",
              "createdDateTimeUTC",
              "updatedBy",
              "updatedDateTimeUTC",
              "addOnServicePublicId",
            ]}
          />
            </div>
          </div>
        </main>
      </div>
      <ConfirmationModal isOpen={confirmState.isOpen} onClose={() => setConfirmState({ isOpen: false })} />
    </>
  );
};

export default CreateAddOnServicePage;
